export enum ChangeRequestTab {
  OVERVIEW = 'Overview',
  TRACKED = 'Tracked Changes',
  LIST = 'Net Changes',
}

export const ChangeRequestTabRoutes: Record<ChangeRequestTab, string> = {
  [ChangeRequestTab.OVERVIEW]: 'overview',
  [ChangeRequestTab.TRACKED]: 'tracked-changes',
  [ChangeRequestTab.LIST]: 'net-changes',
}
